// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TourMenuWeb {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.TourMenuWeb button {\n  pointer-events: auto;\n  z-index: 2;\n  cursor: pointer;\n  border: none;\n  text-decoration: none;\n  outline: none;\n}\n", ""]);
// Exports
module.exports = exports;
